import React from "react";

export default class AreYouAProfessionalBlock extends React.Component 
{
    constructor(props)
    {
        super(props);

        this.env = this.props.env;
        this.requestImageFile = require.context('../images', true);

        this.image = this.env.site === 'dumpster' ? './pro-dumpster-service.jpg' : './contractor-cob.png';

        this.title = this.env.site === 'dumpster' ? 'Are You a Professional Waste Hauler?' : 'Pros Get Started';
        this.text = this.env.site === 'dumpster' ? "More customers visit Hometown Dumpster</br>to hire a disposal service than any other source." : "More customers visit Hometown Demolition</br> to hire a demo pro than any other source.";
        this.button = this.env.site === 'dumpster' ? "Pros Get Started" : "Pros Learn More";
        this.href =  this.env.site === 'dumpster' ? 'https://hometown.wufoo.com/forms/get-started/' : 'https://hometown.wufoo.com/forms/get-started/'

        this.page = this.props.page !== undefined ? ' '+this.props.page : '';
    }

    reviewForm = () =>
    {
        if (typeof window !== "undefined") window.open(this.href,  null, 'height=600, width=680, toolbar=0, location=0, status=1, scrollbars=1, resizable=1'); 
        
        return false
    }
    
    render() 
    {    
        return (
            <section className={"banner-contractor "+this.props.env.site+this.page}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8 pl-m-0">
                            <div className="row align-items-center">
                                <div className="col-12 col-md-5 order-1 order-md-0 text-center p-m-0">
                                    <img className="banner-img" src={this.requestImageFile(this.image)?.default} alt="Pro dumpster service"/>
                                </div>
                                <div className="col-12 col-md-7 text-center order-0 order-md-1">
                                    <h2>{this.title}</h2>
                                    <h4 dangerouslySetInnerHTML={{__html: this.text}}></h4>
                                    <a className="btn btn-success btn-sm btn-lite" href='#' onClick={this.reviewForm}>{this.button}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
};